import type { FC } from 'react';
import FeedCardItem from '@/components/Dashboard/components/FeedCard/FeedCardItem';
import FeedCardLink from '@/components/Dashboard/components/FeedCard/FeedCardLink';
import useCompanyFeed from '@/hooks/useCompanyFeed';
import { Column } from '@simplywallst/ui-core';
import { Bones } from '@/components/Bones';
import { SkeletonRow } from './styled';
export interface Props {
  lookup: string | null;
  limit?: number;
  /** temporary prop until the a/b test is finished */
  showAllEvents?: boolean;
  containerSize?: 'lg' | 'sm';
  isCompanyReport?: boolean;
}

const FeedItemSkeleton: FC = () => (
  <SkeletonRow>
    <Column width="88px">
      <Bones maxWidth="48px" />
    </Column>
    <Column fillVoid>
      <Bones maxWidth="100%" />
      <Bones maxWidth="80%" />
      <Bones maxWidth="95%" />
    </Column>
  </SkeletonRow>
);

export const CompanyFeed: FC<Props> = ({
  lookup,
  limit,
  showAllEvents,
  containerSize,
  isCompanyReport,
}) => {
  const { data, isLoading } = useCompanyFeed(lookup, { limit, showAllEvents });
  return (
    <>
      {(isLoading || lookup === null) && (
        <>
          <FeedItemSkeleton />
          <FeedItemSkeleton />
          <FeedItemSkeleton />
        </>
      )}
      {lookup !== null &&
        !isLoading &&
        typeof data !== 'undefined' &&
        data.events.map((eventRecord, i) => (
          <FeedCardLink
            key={`${i}-${eventRecord.date}-${eventRecord.url}`}
            url={eventRecord.url}
            type={eventRecord.type}
            subType={eventRecord.subType}
            id={eventRecord.id}
            index={i}
            name={data.name}
            tickerSymbol={data.tickerSymbol}
            dateFormatted={eventRecord.dateFormatted}
            title={eventRecord.title || ''}
            virtual={eventRecord.virtual}
            activityId={eventRecord.activityId}
            companyId={data.companyId}
            canonicalUrl={lookup}
            isCompanyReport={isCompanyReport}
          >
            <FeedCardItem
              id={eventRecord.id}
              dateFormatted={eventRecord.dateFormatted}
              type={eventRecord.type}
              outcome={eventRecord.outcome}
              thumbnail={eventRecord.thumbnail}
              text={eventRecord.text}
              title={eventRecord.title}
              containerSize={containerSize}
            />
          </FeedCardLink>
        ))}
    </>
  );
};
